/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as DriverRouteImport } from './routes/driver'
import { Route as QueueRouteImport } from './routes/queue'
import { Route as DevFixturesRouteImport } from './routes/dev.fixtures'
import { Route as ITokenRouteImport } from './routes/i.$token'
import { Route as PTokenRouteImport } from './routes/p.$token'
import { Route as STokenRouteImport } from './routes/s.$token'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const DriverRoute = DriverRouteImport.update({
  id: '/driver',
  path: '/driver',
  getParentRoute: () => rootRouteImport,
} as any)
const QueueRoute = QueueRouteImport.update({
  id: '/queue',
  path: '/queue',
  getParentRoute: () => rootRouteImport,
} as any)
const DevFixturesRoute = DevFixturesRouteImport.update({
  id: '/dev/fixtures',
  path: '/dev/fixtures',
  getParentRoute: () => rootRouteImport,
} as any)
const ITokenRoute = ITokenRouteImport.update({
  id: '/i/$token',
  path: '/i/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const PTokenRoute = PTokenRouteImport.update({
  id: '/p/$token',
  path: '/p/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const STokenRoute = STokenRouteImport.update({
  id: '/s/$token',
  path: '/s/$token',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/driver': typeof DriverRoute
  '/queue': typeof QueueRoute
  '/dev/fixtures': typeof DevFixturesRoute
  '/i/$token': typeof ITokenRoute
  '/p/$token': typeof PTokenRoute
  '/s/$token': typeof STokenRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/driver': typeof DriverRoute
  '/queue': typeof QueueRoute
  '/dev/fixtures': typeof DevFixturesRoute
  '/i/$token': typeof ITokenRoute
  '/p/$token': typeof PTokenRoute
  '/s/$token': typeof STokenRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/driver': typeof DriverRoute
  '/queue': typeof QueueRoute
  '/dev/fixtures': typeof DevFixturesRoute
  '/i/$token': typeof ITokenRoute
  '/p/$token': typeof PTokenRoute
  '/s/$token': typeof STokenRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/driver'
    | '/queue'
    | '/dev/fixtures'
    | '/i/$token'
    | '/p/$token'
    | '/s/$token'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/driver'
    | '/queue'
    | '/dev/fixtures'
    | '/i/$token'
    | '/p/$token'
    | '/s/$token'
  id:
    | '__root__'
    | '/'
    | '/driver'
    | '/queue'
    | '/dev/fixtures'
    | '/i/$token'
    | '/p/$token'
    | '/s/$token'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  DriverRoute: typeof DriverRoute
  QueueRoute: typeof QueueRoute
  DevFixturesRoute: typeof DevFixturesRoute
  ITokenRoute: typeof ITokenRoute
  PTokenRoute: typeof PTokenRoute
  STokenRoute: typeof STokenRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/driver': {
      id: '/driver'
      path: '/driver'
      fullPath: '/driver'
      preLoaderRoute: typeof DriverRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/queue': {
      id: '/queue'
      path: '/queue'
      fullPath: '/queue'
      preLoaderRoute: typeof QueueRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dev/fixtures': {
      id: '/dev/fixtures'
      path: '/dev/fixtures'
      fullPath: '/dev/fixtures'
      preLoaderRoute: typeof DevFixturesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/i/$token': {
      id: '/i/$token'
      path: '/i/$token'
      fullPath: '/i/$token'
      preLoaderRoute: typeof ITokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/p/$token': {
      id: '/p/$token'
      path: '/p/$token'
      fullPath: '/p/$token'
      preLoaderRoute: typeof PTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/s/$token': {
      id: '/s/$token'
      path: '/s/$token'
      fullPath: '/s/$token'
      preLoaderRoute: typeof STokenRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  DriverRoute: DriverRoute,
  QueueRoute: QueueRoute,
  DevFixturesRoute: DevFixturesRoute,
  ITokenRoute: ITokenRoute,
  PTokenRoute: PTokenRoute,
  STokenRoute: STokenRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
